import httpClient from './httpClient';

export interface MetaEnumValueDto {
  basName: string;
  uaName: string;
  basUuid?: string | null;
  orderIdx: number;
}

export interface MetaEnumDto {
  id: string;
  basName: string;
  uaName: string;
  values: MetaEnumValueDto[];
}

export const enumsApi = {
  /** Список усіх імпортованих enum'ів (без values). Для UI вибору. */
  async listEnums(): Promise<MetaEnumDto[]> {
    const res = await httpClient.get<MetaEnumDto[]>('/metadata/enums');
    return res.data;
  },

  /** Один enum зі всіма values. */
  async getEnum(basName: string): Promise<MetaEnumDto> {
    const res = await httpClient.get<MetaEnumDto>(`/metadata/enums/${encodeURIComponent(basName)}`);
    return res.data;
  },
};
